/**
 * @file
 * @auth jinguangguo
 * @date 2017/1/18
 */

import Vue from 'vue';


// include相关
import '../../include/nav/nav';

// alert & confirm & toast
import '../../component/Toast/Toast';


Vue.prototype.reload = function () {
    this.$router.go({
        path: this.$route.path,
        force: true
    });
};

let app = {
    DEBUG: false,
    isPayLocked: false,     // 支付密码是否被锁定
    isAlipayOpen: false,    // 是否开启阿里支付
    realAuth: { // 是否进行过实名认证
        requested: false,
        value: null
    },
    user: { // 当前登录用户的基本信息
        requested: false,
        value: null
    },
    abroad:true,
    loopTradeInfoTimeId: null,
    loopTradeGetListTimeId: null,
    loopDepthMapTimeId: null,
    loopUnReadMessageTimeId: null
};

if (window.location.href.indexOf('localhost') >= 0) {
    app.DEBUG = true;
}

window.app = app;



// WEBPACK FOOTER //
// ./src/js/base/init.js